import { render } from "./SvgAirlinesElectrical.vue?vue&type=template&id=66bf6a50&ts=true"
import script from "./SvgAirlinesElectrical.vue?vue&type=script&lang=ts"
export * from "./SvgAirlinesElectrical.vue?vue&type=script&lang=ts"

import "./SvgAirlinesElectrical.vue?vue&type=style&index=0&id=66bf6a50&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__